import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const ConfigContext = createContext();

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig doit être utilisé dans un ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const { user } = useAuth();
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadConfig();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadConfig = async () => {
    try {
      const { data } = await axios.get('/api/configuration');
      setConfig(data?.data || {});
    } catch (error) {
      console.error('Erreur chargement configuration:', error);
    } finally {
      setLoading(false);
    }
  };

  // Un module est actif par défaut ; masqué uniquement s'il est explicitement désactivé
  const isModuleEnabled = (cle) => {
    const v = config[cle];
    return v !== false && v !== 'false';
  };

  const value = {
    config,
    loading,
    isModuleEnabled,
    marketingEnabled: isModuleEnabled('modules_enabled_marketing'),
    ecommerceEnabled: isModuleEnabled('modules_enabled_ecommerce'),
    loyaltyEnabled: isModuleEnabled('modules_enabled_loyalty'),
    reloadConfig: loadConfig,
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
};
